import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { NotifyStockButtonClickedTrackingEvent, PROJECT, TrackingEventName } from "./tracking";

interface TrackNotifyStockButtonClickedFunctionArgs {
  readonly variantId: string;
}

interface TrackNotifyStockButtonClickedFunction {
  (args: TrackNotifyStockButtonClickedFunctionArgs): void;
}

interface UseTrackNotifyStockButtonClickedFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly tradename: Tradename;
}

interface UseTrackNotifyStockButtonClickedFunction {
  (agrs: UseTrackNotifyStockButtonClickedFunctionArgs): TrackNotifyStockButtonClickedFunction;
}

const useTrackNotifyStockButtonClicked: UseTrackNotifyStockButtonClickedFunction = ({
  country,
  segment,
  tradename,
  userId,
}) => {
  const emitUserEvent = useEmitUserEvent<NotifyStockButtonClickedTrackingEvent>();

  const trackNotifyStockButtonClicked: TrackNotifyStockButtonClickedFunction = useCallback(
    ({ variantId }) => {
      emitUserEvent({
        event: TrackingEventName.NOTIFY_STOCK_BUTTON_CLICKED,
        eventCategory: TrackingEventCategory.LOOK_IN,
        store: country,
        section: PROJECT,
        segment,
        tradename,
        userId,
        userUuid: userId,
        variant_id: variantId,
      });
    },
    [country, emitUserEvent, segment, tradename, userId],
  );

  return trackNotifyStockButtonClicked;
};

export { useTrackNotifyStockButtonClicked };
